import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * Kept for old links. A browser without an unlocked vault is sent to the backup-phrase unlock
 * by the root setup gate; once unlocked there is nothing to recover, so go home.
 */
export const Route = createFileRoute('/recovery')({
  component: () => <Navigate to="/" search={{}} replace />,
});
